import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import oracleimage from '../oracleimage.webp';

const positionTitles = {
    advice: [
        'Supportive resources',
        'Changes needed',
        'Add more',
        'What to surrender?',
        'Opportunity',
        'Action to take'
    ],
    answers: [
        'In your heart',
        'Others opinion',
        'Related issue',
        'Highest Selfs view',
        'Past self',
        'Confusing'
    ],
    astrology: [
        'Heart of the matter',
        'Influencing on practical level',
        'Influencing on emotional level',
        'Opportunity',
        'Challenging factor',
        'Balance out'
    ],
    concepts: [
        'Your environment',
        'How this effects you',
        'An underlying issue',
        'Changes needed',
        'What helps',
        'What hinders'
    ],
    darkLight: [
        'Your Perception',
        'Your Intention',
        'Your Actions',
        'Your Thoughts',
        'Your Conclusion',
        'Your Feelings'
    ],
    essense: [
        'The energy',
        'Hidden Influence',
        'Known Influence',
        'Self',
        'Something you have not considered',
        'Other'
    ],
    messages: [
        'Inner critic represented',
        'How do you sabotage self',
        'What do you tell yourself',
        'What is the truth',
        'How can you love yourself more?',
        'Higher self view'
    ],
    relationships: [
        'Most important',
        'Consider',
        'Helpful',
        'Discern',
        'Possibly',
        'Allow for the other'
    ],
    rootCause: [
        'Unknown Cause',
        'Known Cause',
        'Influencing Outcome',
        'Lighter Influence',
        'Solved',
        'Assisting'
    ],
    scenarios: [
        'Situation',
        'Contributing factor',
        'Surrender',
        'Opportunity',
        'Consider',
        'Embrace'
    ],
    selfCare: [
        'Doing well',
        'Add more',
        'Too much',
        'Give to self',
        'Give away',
        'Solution'
    ]
};

function Oracle({ goBack, goHome }) {
    // Advice state
    const [adviceCards, setAdviceCards] = useState([]);
    const [shuffledAdviceCards, setShuffledAdviceCards] = useState([]);
    const [selectedAdviceCards, setSelectedAdviceCards] = useState([]);
    const [showAdvicePicker, setShowAdvicePicker] = useState(false);
    const pickerRef = useRef(null);

    // Answers state
    const [answersCards, setAnswersCards] = useState([]);
    const [shuffledAnswersCards, setShuffledAnswersCards] = useState([]);
    const [selectedAnswersCards, setSelectedAnswersCards] = useState([]);
    const [showAnswersPicker, setShowAnswersPicker] = useState(false);

    // Astrology state
    const [astrologyCards, setAstrologyCards] = useState([]);
    const [shuffledAstrologyCards, setShuffledAstrologyCards] = useState([]);
    const [selectedAstrologyCards, setSelectedAstrologyCards] = useState([]);
    const [showAstrologyPicker, setShowAstrologyPicker] = useState(false);

    // Concepts state
    const [conceptsCards, setConceptsCards] = useState([]);
    const [shuffledConceptsCards, setShuffledConceptsCards] = useState([]);
    const [selectedConceptsCards, setSelectedConceptsCards] = useState([]);
    const [showConceptsPicker, setShowConceptsPicker] = useState(false);

    // Dark or Light state
    const [darkLightCards, setDarkLightCards] = useState([]);
    const [shuffledDarkLightCards, setShuffledDarkLightCards] = useState([]);
    const [selectedDarkLightCards, setSelectedDarkLightCards] = useState([]);
    const [showDarkLightPicker, setShowDarkLightPicker] = useState(false);

    // Essence (Essense) state
    const [essenseCards, setEssenseCards] = useState([]);
    const [shuffledEssenseCards, setShuffledEssenseCards] = useState([]);
    const [selectedEssenseCards, setSelectedEssenseCards] = useState([]);
    const [showEssensePicker, setShowEssensePicker] = useState(false);

    // Messages state
    const [messagesCards, setMessagesCards] = useState([]);
    const [shuffledMessagesCards, setShuffledMessagesCards] = useState([]);
    const [selectedMessagesCards, setSelectedMessagesCards] = useState([]);
    const [showMessagesPicker, setShowMessagesPicker] = useState(false);

    // Relationships state
    const [relationshipsCards, setRelationshipsCards] = useState([]);
    const [shuffledRelationshipsCards, setShuffledRelationshipsCards] = useState([]);
    const [selectedRelationshipsCards, setSelectedRelationshipsCards] = useState([]);
    const [showRelationshipsPicker, setShowRelationshipsPicker] = useState(false);

    // Root Cause state
    const [rootCauseCards, setRootCauseCards] = useState([]);
    const [shuffledRootCauseCards, setShuffledRootCauseCards] = useState([]);
    const [selectedRootCauseCards, setSelectedRootCauseCards] = useState([]);
    const [showRootCausePicker, setShowRootCausePicker] = useState(false);

    // Scenarios state
    const [scenariosCards, setScenariosCards] = useState([]);
    const [shuffledScenariosCards, setShuffledScenariosCards] = useState([]);
    const [selectedScenariosCards, setSelectedScenariosCards] = useState([]);
    const [showScenariosPicker, setShowScenariosPicker] = useState(false);

    // Self Care state
    const [selfCareCards, setSelfCareCards] = useState([]);
    const [shuffledSelfCareCards, setShuffledSelfCareCards] = useState([]);
    const [selectedSelfCareCards, setSelectedSelfCareCards] = useState([]);
    const [showSelfCarePicker, setShowSelfCarePicker] = useState(false);

    // Fetch Advice cards from Supabase on mount (match Oracle.js: no .schema('public'))
    useEffect(() => {
        async function fetchAdviceCards() {
            // Match Oracle.js: add .schema('public') to the query
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'advice');
            console.log('Supabase advice fetch:', { data, error });
            if (!error && data && data.length > 0) {
                setAdviceCards(data);
                setShuffledAdviceCards([...data]);
            }
        }
        fetchAdviceCards();
    }, []);

    // Fetch Answers cards from Supabase on mount
    useEffect(() => {
        async function fetchAnswersCards() {
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'answers');
            if (!error && data && data.length > 0) {
                setAnswersCards(data);
                setShuffledAnswersCards([...data]);
            }
        }
        fetchAnswersCards();
    }, []);

    // Fetch Astrology cards from Supabase on mount
    useEffect(() => {
        async function fetchAstrologyCards() {
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'Astrology');
            if (!error && data && data.length > 0) {
                setAstrologyCards(data);
                setShuffledAstrologyCards([...data]);
            }
        }
        fetchAstrologyCards();
    }, []);

    // Fetch Concepts cards from Supabase on mount
useEffect(() => {
    async function fetchConceptsCards() {
        const { data, error } = await supabase
            .schema('public')                    // ← ADD THIS LINE
            .from('cards')
            .select('id, title, image_path, descriptions, card_number')
            .eq('component', 'Concepts');

        console.log('Supabase concepts fetch:', { data, error }); // Helpful for debugging

        if (!error && data && data.length > 0) {
            setConceptsCards(data);
            setShuffledConceptsCards([...data]);
        } else if (error) {
            console.error('Concepts fetch error:', error);
        }
    }
    fetchConceptsCards();
    }, []);

    // Fetch Dark or Light cards from Supabase on mount
    useEffect(() => {
        async function fetchDarkLightCards() {
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'darkandlight');
            if (!error && data && data.length > 0) {
                setDarkLightCards(data);
                setShuffledDarkLightCards([...data]);
            }
        }
        fetchDarkLightCards();
    }, []);

    // Fetch Essense cards from Supabase on mount
    useEffect(() => {
        async function fetchEssenseCards() {
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'Essense');
            if (!error && data && data.length > 0) {
                setEssenseCards(data);
                setShuffledEssenseCards([...data]);
            }
        }
        fetchEssenseCards();
    }, []);

    // Fetch Messages cards from Supabase on mount
    useEffect(() => {
        async function fetchMessagesCards() {
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'messages');
            if (!error && data && data.length > 0) {
                setMessagesCards(data);
                setShuffledMessagesCards([...data]);
            }
        }
        fetchMessagesCards();
    }, []);

    // Fetch Relationships cards from Supabase on mount
    useEffect(() => {
        async function fetchRelationshipsCards() {
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'Relationships');
            if (!error && data && data.length > 0) {
                setRelationshipsCards(data);
                setShuffledRelationshipsCards([...data]);
            }
        }
        fetchRelationshipsCards();
    }, []);

    // Fetch Root Cause cards from Supabase on mount
    useEffect(() => {
        async function fetchRootCauseCards() {
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'rootcause');
            if (!error && data && data.length > 0) {
                setRootCauseCards(data);
                setShuffledRootCauseCards([...data]);
            }
        }
        fetchRootCauseCards();
    }, []);

    // Fetch Scenarios cards from Supabase on mount
    useEffect(() => {
        async function fetchScenariosCards() {
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'scenarios');
            if (!error && data && data.length > 0) {
                setScenariosCards(data);
                setShuffledScenariosCards([...data]);
            }
        }
        fetchScenariosCards();
    }, []);

    // Fetch Self Care cards from Supabase on mount
    useEffect(() => {
        async function fetchSelfCareCards() {
            const { data, error } = await supabase
                .schema('public')
                .from('cards')
                .select('id, title, image_path, descriptions, card_number')
                .eq('component', 'SelfCare');
            if (!error && data && data.length > 0) {
                setSelfCareCards(data);
                setShuffledSelfCareCards([...data]);
            }
        }
        fetchSelfCareCards();
    }, []);

    // Shuffle function (same as Oracle.js)
    function shuffleArray(array) {
        const arr = [...array];
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    }

    // Start Card Reading (same logic as Oracle.js)
    // eslint-disable-next-line no-unused-vars
    const handleStartAdviceReading = () => {
        setShowAdvicePicker(true);
        setSelectedAdviceCards([]);
        setShuffledAdviceCards(shuffleArray(adviceCards));
    };

    const handleHideAdvicePicker = () => {
        setShowAdvicePicker(false);
    };

    // Card click logic (same as Oracle.js)
    const handleAdviceCardClick = (card, idx) => {
        if (selectedAdviceCards.length < 6 && !selectedAdviceCards.some(c => c.id === card.id)) {
            setSelectedAdviceCards([...selectedAdviceCards, { ...card, position: idx }]);
        }
    };

    // Answers picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartAnswersReading = () => {
        setShowAnswersPicker(true);
        setSelectedAnswersCards([]);
        setShuffledAnswersCards(shuffleArray(answersCards));
    };

    const handleHideAnswersPicker = () => {
        setShowAnswersPicker(false);
    };

    const handleAnswersCardClick = (card, idx) => {
        if (selectedAnswersCards.length < 6 && !selectedAnswersCards.some(c => c.id === card.id)) {
            setSelectedAnswersCards([...selectedAnswersCards, { ...card, position: idx }]);
        }
    };

    // Astrology picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartAstrologyReading = () => {
        setShowAstrologyPicker(true);
        setSelectedAstrologyCards([]);
        setShuffledAstrologyCards(shuffleArray(astrologyCards));
    };

    const handleHideAstrologyPicker = () => {
        setShowAstrologyPicker(false);
    };

    const handleAstrologyCardClick = (card, idx) => {
        if (selectedAstrologyCards.length < 6 && !selectedAstrologyCards.some(c => c.id === card.id)) {
            setSelectedAstrologyCards([...selectedAstrologyCards, { ...card, position: idx }]);
        }
    };

    // Concepts picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartConceptsReading = () => {
        setShowConceptsPicker(true);
        setSelectedConceptsCards([]);
        setShuffledConceptsCards(shuffleArray(conceptsCards));
    };

    const handleHideConceptsPicker = () => {
        setShowConceptsPicker(false);
    };

    const handleConceptsCardClick = (card, idx) => {
        if (selectedConceptsCards.length < 6 && !selectedConceptsCards.some(c => c.id === card.id)) {
            setSelectedConceptsCards([...selectedConceptsCards, { ...card, position: idx }]);
        }
    };

    // Dark or Light picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartDarkLightReading = () => {
        setShowDarkLightPicker(true);
        setSelectedDarkLightCards([]);
        setShuffledDarkLightCards(shuffleArray(darkLightCards));
    };

    const handleHideDarkLightPicker = () => {
        setShowDarkLightPicker(false);
    };

    const handleDarkLightCardClick = (card, idx) => {
        if (selectedDarkLightCards.length < 6 && !selectedDarkLightCards.some(c => c.id === card.id)) {
            setSelectedDarkLightCards([...selectedDarkLightCards, { ...card, position: idx }]);
        }
    };

    // Essence picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartEssenseReading = () => {
        setShowEssensePicker(true);
        setSelectedEssenseCards([]);
        setShuffledEssenseCards(shuffleArray(essenseCards));
    };

    const handleHideEssensePicker = () => {
        setShowEssensePicker(false);
    };

    const handleEssenseCardClick = (card, idx) => {
        if (selectedEssenseCards.length < 6 && !selectedEssenseCards.some(c => c.id === card.id)) {
            setSelectedEssenseCards([...selectedEssenseCards, { ...card, position: idx }]);
        }
    };

    // Messages picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartMessagesReading = () => {
        setShowMessagesPicker(true);
        setSelectedMessagesCards([]);
        setShuffledMessagesCards(shuffleArray(messagesCards));
    };

    const handleHideMessagesPicker = () => {
        setShowMessagesPicker(false);
    };

    const handleMessagesCardClick = (card, idx) => {
        if (selectedMessagesCards.length < 6 && !selectedMessagesCards.some(c => c.id === card.id)) {
            setSelectedMessagesCards([...selectedMessagesCards, { ...card, position: idx }]);
        }
    };

    // Relationships picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartRelationshipsReading = () => {
        setShowRelationshipsPicker(true);
        setSelectedRelationshipsCards([]);
        setShuffledRelationshipsCards(shuffleArray(relationshipsCards));
    };

    const handleHideRelationshipsPicker = () => {
        setShowRelationshipsPicker(false);
    };

    const handleRelationshipsCardClick = (card, idx) => {
        if (selectedRelationshipsCards.length < 6 && !selectedRelationshipsCards.some(c => c.id === card.id)) {
            setSelectedRelationshipsCards([...selectedRelationshipsCards, { ...card, position: idx }]);
        }
    };

    // Root Cause picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartRootCauseReading = () => {
        setShowRootCausePicker(true);
        setSelectedRootCauseCards([]);
        setShuffledRootCauseCards(shuffleArray(rootCauseCards));
    };

    const handleHideRootCausePicker = () => {
        setShowRootCausePicker(false);
    };

    const handleRootCauseCardClick = (card, idx) => {
        if (selectedRootCauseCards.length < 6 && !selectedRootCauseCards.some(c => c.id === card.id)) {
            setSelectedRootCauseCards([...selectedRootCauseCards, { ...card, position: idx }]);
        }
    };

    // Scenarios picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartScenariosReading = () => {
        setShowScenariosPicker(true);
        setSelectedScenariosCards([]);
        setShuffledScenariosCards(shuffleArray(scenariosCards));
    };

    const handleHideScenariosPicker = () => {
        setShowScenariosPicker(false);
    };

    const handleScenariosCardClick = (card, idx) => {
        if (selectedScenariosCards.length < 6 && !selectedScenariosCards.some(c => c.id === card.id)) {
            setSelectedScenariosCards([...selectedScenariosCards, { ...card, position: idx }]);
        }
    };

    // Self Care picker logic
    // eslint-disable-next-line no-unused-vars
    const handleStartSelfCareReading = () => {
        setShowSelfCarePicker(true);
        setSelectedSelfCareCards([]);
        setShuffledSelfCareCards(shuffleArray(selfCareCards));
    };

    const handleHideSelfCarePicker = () => {
        setShowSelfCarePicker(false);
    };

    const handleSelfCareCardClick = (card, idx) => {
        if (selectedSelfCareCards.length < 6 && !selectedSelfCareCards.some(c => c.id === card.id)) {
            setSelectedSelfCareCards([...selectedSelfCareCards, { ...card, position: idx }]);
        }
    };

    const adviceCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/Advice/advicebackimage.webp';
    const answersCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/Answers/aanswersbackimage.webp';
    const astrologyCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/Astrology/Astrology%20Back00.webp';
    const ConceptsCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/Concepts/cbackimage.webp';
    const darkLightCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/DarkandLight/darkandlightback1.webp';
    const essenseCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/Essense/Essense%20Back002.webp';
    const messagesCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/messages/mbackimage.webp';
    const relationshipsCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/FairRelating/FairRelating%20Back001.webp';
    const rootCauseCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/RootCause/rcbackimage.webp';
    const scenariosCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/scenarios/sbackimage.webp';
    const selfCareCardBack = 'https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/card-images/scback094.webp';

    return (
        <div
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                width: '100vw',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: 0,
                boxSizing: 'border-box',
                paddingBottom: '80px',
            }}
        >
            <h2
                style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '32px',
                    fontWeight: 'bold',
                    color: '#4B5563',
                    margin: '32px 0 24px 0',
                    textAlign: 'center',
                }}
            >
                Oracle
            </h2>
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    minHeight: '120px',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    borderRadius: '10px',
                    border: '2px solid #4B5563',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    margin: '0 auto',
                    textAlign: 'center',
                }}
            >
                <img
                    src={oracleimage}
                    alt="Oracle"
                    style={{
                        width: '100%',
                        maxWidth: '320px',
                        borderRadius: '10px',
                        display: 'block',
                        margin: '0 auto',
                        marginBottom: '16px',
                    }}
                />
                <p
                    style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '20px',
                        fontWeight: 'bold',
                        margin: '0',
                        textAlign: 'center',
                    }}
                >
                    This Oracle is meant to offer you information to reflect on. This Oracle is not meant for prediction. You should always refer back to your inner self and decide what resonates as true for you. The readings offered here can help give you information to reflect on. Ultimately it is your own responsibility to decide and discern what is relevant to you and what is not. 
                </p>
            </div>
            {/* Advice Card Picker Display */}
            {showAdvicePicker && shuffledAdviceCards.length > 0 && (
                <div
                    ref={pickerRef}
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        minHeight: window.innerWidth <= 768 ? undefined : '320px',
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledAdviceCards;
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            let numRows, cardsPerRow, rowGap;
                            if (window.innerWidth <= 768) {
                                numRows = 3;
                                rowGap = 8; // <-- Reduce gap for mobile
                            } else {
                                numRows = 2;
                                rowGap = 8; // <-- Reduce gap for desktop
                            }
                            cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`advice-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0', // <-- Use reduced gap
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                // Ensure last card in each row is fully visible
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `advice-row-${rowIdx}-${card.id}` : `advice-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedAdviceCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleAdviceCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={adviceCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Advice Reading Display */}
            {selectedAdviceCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        // boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // <-- Remove this line for no shadow
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedAdviceCards.slice(0, 6).map((card, idx) => (
                            <div key={card.id} style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                minHeight: '200px',
                            }}>
                                <p style={{
                                    fontFamily: 'Times New Roman, Times, serif',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    margin: '4px 0',
                                    textAlign: 'center',
                                }}>
                                    {positionTitles.advice[idx] || `Advice ${idx + 1}`}
                                </p>
                                <img
                                    src={
                                        card.image_path
                                            ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path.replace('card-images/advice/', 'card-images/Advice/')}`
                                            : card.image
                                    }
                                    alt={card.title}
                                    style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                />
                                <p style={{
                                    fontFamily: 'Times New Roman, Times, serif',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    marginTop: '8px',
                                    textAlign: 'center',
                                    wordWrap: 'break-word',
                                    maxWidth: '150px',
                                    minHeight: '1em',
                                }}>
                                    {
                                        Array.isArray(card.descriptions)
                                            ? (card.descriptions[idx] && card.descriptions[idx].trim() ? card.descriptions[idx] : '')
                                            : (typeof card.descriptions === 'string' && card.descriptions.trim() ? card.descriptions : '')
                                    }
                                </p>
                            </div>
                        ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedAdviceCards.length }).map((_, idx) => (
                            <div key={`empty-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Advice Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Advice
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        // Always reset the reading and picker state
                        setShowAdvicePicker(true);
                        setSelectedAdviceCards([]);
                        setShuffledAdviceCards(shuffleArray(adviceCards));
                    }}
                    disabled={adviceCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showAdvicePicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideAdvicePicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            {/* Answers Card Picker Display */}
            {showAnswersPicker && shuffledAnswersCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        minHeight: window.innerWidth <= 768 ? undefined : undefined,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledAnswersCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('aanswersbackimage.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            // Always use 2 rows for Answers picker
                            const numRows = 2;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`answers-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `answers-row-${rowIdx}-${card.id}` : `answers-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedAnswersCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleAnswersCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={answersCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Answers Reading Display */}
            {selectedAnswersCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedAnswersCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('aanswersbackimage.png')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.answers[idx] || `Answer ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path.replace('card-images/answers/', 'card-images/Answers/')}`
                                                : answersCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedAnswersCards.filter(card =>
                            !card.image_path?.toLowerCase().includes('aanswersbackimage.webp')
                        ).length }).map((_, idx) => (
                            <div key={`empty-answer-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Answers Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Answers
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        setShowAnswersPicker(true);
                        setSelectedAnswersCards([]);
                        setShuffledAnswersCards(shuffleArray(answersCards));
                    }}
                    disabled={answersCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showAnswersPicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideAnswersPicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            {/* Astrology Card Picker Display */}
            {showAstrologyPicker && shuffledAstrologyCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledAstrologyCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('astrology back00.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            // Use 6 rows for mobile, 3 rows for desktop
                            const numRows = window.innerWidth <= 768 ? 6 : 3;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`astrology-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `astrology-row-${rowIdx}-${card.id}` : `astrology-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedAstrologyCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleAstrologyCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={astrologyCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Astrology Reading Display */}
            {selectedAstrologyCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedAstrologyCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('astrology back00.png')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.astrology[idx] || `Astrology ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path.replace('card-images/astrology/', 'card-images/Astrology/')}`
                                                : astrologyCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedAstrologyCards.filter(card =>
                            !card.image_path?.toLowerCase().includes('astrology back00.webp')
                        ).length }).map((_, idx) => (
                            <div key={`empty-astrology-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Astrology Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Astrology
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        setShowAstrologyPicker(true);
                        setSelectedAstrologyCards([]);
                        setShuffledAstrologyCards(shuffleArray(astrologyCards));
                    }}
                    disabled={astrologyCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showAstrologyPicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideAstrologyPicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            {/* Concepts Card Picker Display */}
            {showConceptsPicker && shuffledConceptsCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledConceptsCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('cbackimage.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            // Use 10 rows for mobile, 5 rows for desktop
                            const numRows = window.innerWidth <= 768 ? 10 : 5;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`concepts-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `concepts-row-${rowIdx}-${card.id}` : `concepts-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedConceptsCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleConceptsCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={ConceptsCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Concepts Reading Display */}
            {selectedConceptsCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedConceptsCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('cbackimage.webp')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.concepts[idx] || `Concept ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path.replace('card-images/concepts/', 'card-images/Concepts/')}`
                                                : ConceptsCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedConceptsCards.length }).map((_, idx) => (
                            <div key={`empty-concepts-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Concepts Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Concepts
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={handleStartConceptsReading}
                    disabled={conceptsCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showConceptsPicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideConceptsPicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            {/* Dark or Light Card Picker Display */}
            {showDarkLightPicker && shuffledDarkLightCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledDarkLightCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('darkandlightback1.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            const numRows = 2;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`darklight-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `darklight-row-${rowIdx}-${card.id}` : `darklight-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedDarkLightCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleDarkLightCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={darkLightCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Dark or Light Reading Display */}
            {selectedDarkLightCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedDarkLightCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('darkandlightback1.jpg')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.darkLight[idx] || `Dark or Light ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path.replace('card-images/darkandlight/', 'card-images/DarkandLight/')}`

                                                : darkLightCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedDarkLightCards.filter(card =>
                            !card.image_path?.toLowerCase().includes('darkandlightback1.webp')
                        ).length }).map((_, idx) => (
                            <div key={`empty-darklight-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Dark or Light Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Dark or Light
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        setShowDarkLightPicker(true);
                        setSelectedDarkLightCards([]);
                        setShuffledDarkLightCards(shuffleArray(darkLightCards));
                    }}
                    disabled={darkLightCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showDarkLightPicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideDarkLightPicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            {/* Essense Card Picker Display */}
            {showEssensePicker && shuffledEssenseCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledEssenseCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('essense back002.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            const numRows = 2;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`essense-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `essense-row-${rowIdx}-${card.id}` : `essense-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedEssenseCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleEssenseCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={essenseCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Essense Reading Display */}
            {selectedEssenseCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedEssenseCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('essense back002.jpg')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.essense[idx] || `Essence ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path}`
                                                : essenseCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedEssenseCards.filter(card =>
                            !card.image_path?.toLowerCase().includes('essense back002.webp')
                        ).length }).map((_, idx) => (
                            <div key={`empty-essense-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Essense Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Essence
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        setShowEssensePicker(true);
                        setSelectedEssenseCards([]);
                        setShuffledEssenseCards(shuffleArray(essenseCards));
                    }}
                    disabled={essenseCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showEssensePicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideEssensePicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            {/* Messages Card Picker Display */}
            {showMessagesPicker && shuffledMessagesCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        minHeight: window.innerWidth <= 768 ? undefined : undefined,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledMessagesCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('mbackimage.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            // Use 2 rows for browser, keep mobile as is (2 rows)
                            const numRows = window.innerWidth <= 768 ? 2 : 2;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`messages-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `messages-row-${rowIdx}-${card.id}` : `messages-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedMessagesCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleMessagesCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={messagesCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Messages Reading Display */}
            {selectedMessagesCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedMessagesCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('mbackimage.png')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.messages[idx] || `Message ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path}`
                                                : messagesCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedMessagesCards.filter(card =>
                            !card.image_path?.toLowerCase().includes('mbackimage.webp')
                        ).length }).map((_, idx) => (
                            <div key={`empty-messages-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Messages Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Messages
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        setShowMessagesPicker(true);
                        setSelectedMessagesCards([]);
                        setShuffledMessagesCards(shuffleArray(messagesCards));
                    }}
                    disabled={messagesCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showMessagesPicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideMessagesPicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            {/* Relationships Card Picker Display */}
            {showRelationshipsPicker && shuffledRelationshipsCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledRelationshipsCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('fairrelating back001.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            const numRows = 2;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`relationships-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `relationships-row-${rowIdx}-${card.id}` : `relationships-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedRelationshipsCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleRelationshipsCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={relationshipsCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Relationships Reading Display */}
            {selectedRelationshipsCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedRelationshipsCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('fairrelating back001.jpg')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.relationships[idx] || `Relationship ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path.replace('card-images/fairrelating/', 'card-images/FairRelating/')}`
                                                : relationshipsCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedRelationshipsCards.filter(card =>
                            !card.image_path?.toLowerCase().includes('fairrelating back001.webp')
                        ).length }).map((_, idx) => (
                            <div key={`empty-relationships-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Relationships Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Relationships
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        setShowRelationshipsPicker(true);
                        setSelectedRelationshipsCards([]);
                        setShuffledRelationshipsCards(shuffleArray(relationshipsCards));
                    }}
                    disabled={relationshipsCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showRelationshipsPicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideRelationshipsPicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            {/* Root Cause Card Picker Display */}
            {showRootCausePicker && shuffledRootCauseCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledRootCauseCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('rcbackimage.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            // 4 rows for mobile, 2 rows for desktop
                            const numRows = window.innerWidth <= 768 ? 4 : 2;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`rootcause-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `rootcause-row-${rowIdx}-${card.id}` : `rootcause-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedRootCauseCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleRootCauseCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={rootCauseCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Root Cause Reading Display */}
            {selectedRootCauseCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedRootCauseCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('rcbackimage.png')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.rootCause[idx] || `Root Cause ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path.replace('card-images/rootcause/', 'card-images/RootCause/')}`
                                                : rootCauseCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedRootCauseCards.filter(card =>
                            !card.image_path?.toLowerCase().includes('rcbackimage.webp')
                        ).length }).map((_, idx) => (
                            <div key={`empty-rootcause-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Root Cause Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Root Cause
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        setShowRootCausePicker(true);
                        setSelectedRootCauseCards([]);
                        setShuffledRootCauseCards(shuffleArray(rootCauseCards));
                    }}
                    disabled={rootCauseCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showRootCausePicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideRootCausePicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            {/* Scenarios Card Picker Display */}
            {showScenariosPicker && shuffledScenariosCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledScenariosCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('sbackimage.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            const numRows = 2;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`scenarios-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `scenarios-row-${rowIdx}-${card.id}` : `scenarios-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedScenariosCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleScenariosCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={scenariosCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Scenarios Reading Display */}
            {selectedScenariosCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedScenariosCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('sbackimage.png')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.scenarios[idx] || `Scenario ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path}`
                                                : scenariosCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedScenariosCards.filter(card =>
                            !card.image_path?.toLowerCase().includes('sbackimage.webp')
                        ).length }).map((_, idx) => (
                            <div key={`empty-scenarios-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Scenarios Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Scenarios
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        setShowScenariosPicker(true);
                        setSelectedScenariosCards([]);
                        setShuffledScenariosCards(shuffleArray(scenariosCards));
                    }}
                    disabled={scenariosCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showScenariosPicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideScenariosPicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>

            {/* Self Care Card Picker Display */}
            {showSelfCarePicker && shuffledSelfCareCards.length > 0 && (
                <div
                    style={{
                        width: window.innerWidth <= 768 ? '100vw' : '1000px',
                        maxWidth: window.innerWidth <= 768 ? '100vw' : '1000px',
                        margin: '0 auto',
                        padding: '10px 0',
                        background: 'white',
                        border: '2px solid #4B5563',
                        borderRadius: '8px',
                        zIndex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: 'none',
                    }}
                >
                    <div style={{
                        display: 'block',
                        verticalAlign: 'top',
                        position: 'relative',
                        padding: '0',
                        textAlign: 'left',
                        overflow: 'visible',
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        marginLeft: '6px',
                        marginRight: '6px',
                    }}>
                        {(() => {
                            const cards = shuffledSelfCareCards.filter(card =>
                                !card.image_path?.toLowerCase().includes('scback094.webp')
                            );
                            const totalCards = cards.length;
                            const cardWidth = 150;
                            const cardHeight = 150;
                            const margin = 6;
                            const numRows = 2;
                            const rowGap = 8;
                            const containerWidth = (window.innerWidth <= 768 ? window.innerWidth : 1000) - 2 * margin;
                            const cardsPerRow = Math.ceil(totalCards / numRows);
                            const overlapPx = cardsPerRow > 1
                                ? Math.floor((cardWidth * cardsPerRow - containerWidth) / (cardsPerRow - 1))
                                : 0;
                            const effectiveOverlap = overlapPx > 0 ? overlapPx : 0;
                            // Dynamically create rows
                            const rows = [];
                            for (let i = 0; i < totalCards; i++) {
                                const rowIdx = Math.floor(i / cardsPerRow);
                                if (!rows[rowIdx]) rows[rowIdx] = [];
                                rows[rowIdx].push(cards[i]);
                            }
                            const containerHeight = numRows * cardHeight + (numRows - 1) * rowGap;
                            return (
                                <div
                                    style={{
                                        width: `${containerWidth}px`,
                                        minWidth: '300px',
                                        position: 'relative',
                                        height: `${containerHeight}px`,
                                        background: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {rows.map((rowCards, rowIdx) => (
                                        <div
                                            key={`selfcare-row-${rowIdx}`}
                                            style={{
                                                position: 'absolute',
                                                top: `${rowIdx * (cardHeight + rowGap)}px`,
                                                left: 0,
                                                height: `${cardHeight}px`,
                                                width: `${containerWidth}px`,
                                                minWidth: '300px',
                                                overflowX: 'visible',
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                marginBottom: rowIdx < numRows - 1 ? `${rowGap}px` : '0',
                                            }}
                                        >
                                            {rowCards.map((card, idx) => {
                                                const left = idx * (cardWidth - effectiveOverlap);
                                                const maxLeft = containerWidth - cardWidth;
                                                const adjustedLeft = Math.min(left, maxLeft);
                                                const zIndex = idx;
                                                const key = card?.id ? `selfcare-row-${rowIdx}-${card.id}` : `selfcare-row-${rowIdx}-${idx}`;
                                                return (
                                                    <div
                                                        key={key}
                                                        data-position={idx}
                                                        style={{
                                                            width: `${cardWidth}px`,
                                                            height: `${cardHeight}px`,
                                                            position: 'absolute',
                                                            left: `${adjustedLeft}px`,
                                                            top: '0px',
                                                            cursor: 'pointer',
                                                            borderRadius: '4px',
                                                            boxShadow: 'none',
                                                            zIndex: zIndex,
                                                            transition: 'transform 0.3s, opacity 0.3s',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            ...(idx === rowCards.length - 1 ? { zIndex: 100 } : {}),
                                                            opacity: selectedSelfCareCards.some(c => c.id === card.id) ? 0.5 : 1,
                                                        }}
                                                        onClick={() => handleSelfCareCardClick(card, idx)}
                                                    >
                                                        <img
                                                            src={selfCareCardBack}
                                                            alt=""
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                                pointerEvents: 'none',
                                                                userSelect: 'none',
                                                                display: 'block',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                boxShadow: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}
            {/* Self Care Reading Display */}
            {selectedSelfCareCards.length > 0 && (
                <div
                    style={{
                        width: '100%',
                        maxWidth: window.innerWidth <= 768 ? '400px' : '1000px',
                        margin: '0 auto 32px auto',
                        background: 'white',
                        border: '2px solid black',
                        padding: '12px',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        zIndex: 1,
                        minHeight: '320px',
                        minWidth: window.innerWidth <= 768 ? '300px' : '600px',
                    }}
                >
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gridTemplateRows: 'repeat(2, 1fr)',
                        gap: '8px',
                        ...(window.innerWidth <= 768 && {
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridTemplateRows: 'repeat(3, 1fr)',
                        }),
                    }}>
                        {selectedSelfCareCards
                            .filter(card =>
                                !card.image_path?.toLowerCase().includes('scback094.jpg')
                            )
                            .slice(0, 6)
                            .map((card, idx) => (
                                <div key={card.id} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.3), 0 -4px 6px rgba(0,0,0,0.3)',
                                    minHeight: '200px',
                                }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        margin: '4px 0',
                                        textAlign: 'center',
                                    }}>
                                        {positionTitles.selfCare[idx] || `Self Care ${idx + 1}`}
                                    </p>
                                    <img
                                        src={
                                            card.image_path
                                                ? `https://zxvjqkrfvproyblrjcst.supabase.co/storage/v1/object/public/${card.image_path}`
                                                : selfCareCardBack
                                        }
                                        alt={card.title}
                                        style={{ width: '150px', height: '150px', objectFit: 'contain', transition: 'transform 0.2s' }}
                                    />
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        maxWidth: '150px',
                                    }}>
                                        {card && typeof card.descriptions === 'string' && card.descriptions.trim()
                                            ? card.descriptions
                                            : ''}
                                    </p>
                                </div>
                            ))}
                        {/* Fill empty slots if less than 6 cards picked */}
                        {Array.from({ length: 6 - selectedSelfCareCards.filter(card =>
                            !card.image_path?.toLowerCase().includes('scback094.jpg')
                        ).length }).map((_, idx) => (
                            <div key={`empty-selfcare-${idx}`} style={{
                                width: '150px',
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '8px',
                                margin: '8px auto',
                            }} />
                        ))}
                    </div>
                </div>
            )}
            {/* Self Care Card UI Card with buttons BELOW displays */}
            <div
                style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid #4B5563',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    maxWidth: '300px',
                    margin: '32px auto 0 auto',
                }}
            >
                <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '18px', color: '#4B5563' }}>
                    Self Care
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        border: '2px solid #4B5563',
                        borderRadius: '10px',
                        padding: '5px 10px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        marginTop: '8px',
                        zIndex: 10,
                    }}
                    onClick={() => {
                        setShowSelfCarePicker(true);
                        setSelectedSelfCareCards([]);
                        setShuffledSelfCareCards(shuffleArray(selfCareCards));
                    }}
                    disabled={selfCareCards.length === 0}
                >
                    Start Card Reading
                </button>
                {showSelfCarePicker && (
                    <button
                        style={{
                            backgroundImage: `url(${cardBackgroundImage})`,
                            border: '2px solid #4B5563',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            marginTop: '8px',
                            zIndex: 10,
                        }}
                        onClick={handleHideSelfCarePicker}
                    >
                        Hide Card Picker
                    </button>
                )}
            </div>
            <footer
                style={{
                    position: 'fixed',
                    bottom: '0',
                    left: '0',
                    width: '100%',
		    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px 10px 0 0',
                    boxShadow: '3px 3px 5px rgba(0, 0, 0, 0.3)',
                    padding: '2px',
                    textAlign: 'center',
                    zIndex: '1000',
                    minHeight: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '55px',
                }}
            >
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '5px 5px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        zIndex: '1000',
                    }}
                    onClick={goBack}
                >
                    Back
                </button>
                <button
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '5px 5px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        zIndex: '1000',
                    }}
                    onClick={goHome}
                >
                    Home
                </button>
            </footer>
        </div>
    );
}

export default Oracle;